import axios from "axios";

export function isAxiosError(
  error: unknown,
): error is { response?: { data?: { message?: string; error?: string } } } {
  return axios.isAxiosError(error);
}

export function getErrorMessage(
  error: unknown,
  fallback = "Something went wrong",
): string {
  if (isAxiosError(error)) {
    return error.response?.data?.message ?? fallback;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return fallback;
}

export function isNetworkError(error: unknown): boolean {
  return isAxiosError(error) && !error.response;
}

export const OFFLINE_MESSAGE =
  "No internet connection. Please check your network and try again.";
